<label class="switch">
  <input type="checkbox" (change)="onToggleChange()" />
  <span class="slider round">
    <img src="assets/icons/check-circle.svg" alt="" class="check-icon" />
  </span>
</label>